import { Box, makeStyles, Paper } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        borderRadius: "4px",
        border: `1px solid ${theme.palette.ascents.primary}`,
        overflow: "hidden",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2, 1)
        }
    },
    MuiPaper: {
        marginTop: theme.spacing(2),
        borderRadius: "4px",
        background: `linear-gradient(45deg, ${theme.palette.ascents.primary}, ${theme.palette.ascents.orange})`
    }
}));


const PaperWrapper = ({
    children,
    padding = 5,
    margin = 0,
    paperProps,
    ...props
}) => {
    const classes = useStyles({});

    return (
        <Paper
            className={clsx(classes.MuiPaper)}
            {...paperProps}
        >
            <Box
                p={padding}
                m={margin}
                className={clsx(classes.root)}
                {...props}
            >
                {children}
            </Box>
        </Paper>
    )
}

export default PaperWrapper
